{
    "apiKey": "AIzaSyA3CgvXiSOeAgMaroA35YDp5ZfnyblDvq4",
    "authDomain": "biozone-world-staging.firebaseapp.com",
    "projectId": "biozone-world-staging",
    "storageBucket": "biozone-world-staging.appspot.com",
    "messagingSenderId": "549241736987",
    "appId": "1:549241736987:web:60cb3fab267f404820cdbe"
}
